import { render, staticRenderFns } from "./TutorialBar.vue?vue&type=template&id=0afa1a23&scoped=true&"
import script from "./TutorialBar.vue?vue&type=script&lang=js&"
export * from "./TutorialBar.vue?vue&type=script&lang=js&"
import style0 from "./TutorialBar.scss?vue&type=style&index=0&id=0afa1a23&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0afa1a23",
  null
  
)

export default component.exports